<button mat-icon-button [matTooltip]="content" [matTooltipPosition]="position" [tabIndex]="-1">
	<i class="{{ icon }}"></i>
</button>
